import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiDatabase, FiLock, FiMail } from 'react-icons/fi';

export default function SuperLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await login(email, password);

      // Super Admin 체크
      if (data.user.role !== 'super') {
        setError('Super Admin 권한이 필요합니다');
        return;
      }

      navigate('/super');
    } catch (err) {
      setError(err.response?.data?.error || '로그인에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page super-login-page">
      <div className="login-container">
        <div className="login-header">
          <FiDatabase className="login-icon super-icon" />
          <h1>EduStaff</h1>
          <p>Super Admin Panel</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label>
              <FiMail /> 이메일
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="super@edustaff.co.kr"
              required
            />
          </div>

          <div className="form-group">
            <label>
              <FiLock /> 비밀번호
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? '로그인 중...' : 'Super Admin 로그인'}
          </button>
        </form>

        <div className="login-footer">
          <p>일반 사용자는 <a href="/login">여기</a>에서 로그인하세요</p>
        </div>
      </div>
    </div>
  );
}
